import type { CustomerDataWithStatus } from '@packages/shared/src/hooks/useCustomer/useCustomer';
import * as zod from 'zod';
import type { IntlShape } from 'react-intl';
import type { FormValues } from '../../types';
import { CheckboxIDs, InputIDs } from '../../types';
import { noSpecCharsNoNumbers } from '../../helpers/validationSchema';
import { formMessages, specialErrorMessages } from '../../messages';

const genderSalutationMap = {
  m: 'male',
  f: 'female',
  d: 'notSpecified',
};
export const getDefaultValues = (customer: CustomerDataWithStatus | undefined): FormValues => ({
  [InputIDs.FIRSTNAME]: customer?.firstName ?? '',
  [InputIDs.LASTNAME]: customer?.lastName ?? '',
  [InputIDs.EMAIL]: customer?.email ?? '',
  [InputIDs.SALUTATION]: customer?.gender && genderSalutationMap[customer.gender],
});

export const newsletterSubscribeFormSchema = (intl: IntlShape) =>
  zod.object({
    [InputIDs.SALUTATION]: zod.string().optional(),
    [InputIDs.FIRSTNAME]: zod
      .string()
      .regex(noSpecCharsNoNumbers, intl.formatMessage(specialErrorMessages.noSpecCharsNoNumbers))
      .optional(),
    [InputIDs.LASTNAME]: zod
      .string()
      .regex(noSpecCharsNoNumbers, intl.formatMessage(specialErrorMessages.noSpecCharsNoNumbers))
      .optional(),
    [InputIDs.EMAIL]: zod
      .string()
      .email(intl.formatMessage(formMessages[InputIDs.EMAIL].error.valid))
      .nonempty({ message: intl.formatMessage(formMessages[InputIDs.EMAIL].error) })
      .regex(
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/,
        intl.formatMessage(formMessages[InputIDs.EMAIL].error.valid),
      ),
  });

export const newsletterSubscribeFormSchemaWithApproval = (intl: IntlShape) =>
  zod.object({
    [InputIDs.SALUTATION]: zod.string().optional(),
    [InputIDs.FIRSTNAME]: zod
      .string()
      .regex(noSpecCharsNoNumbers, intl.formatMessage(specialErrorMessages.noSpecCharsNoNumbers))
      .optional(),
    [InputIDs.LASTNAME]: zod
      .string()
      .regex(noSpecCharsNoNumbers, intl.formatMessage(specialErrorMessages.noSpecCharsNoNumbers))
      .optional(),
    [InputIDs.EMAIL]: zod
      .string()
      .email(intl.formatMessage(formMessages[InputIDs.EMAIL].error.valid))
      .nonempty({ message: intl.formatMessage(formMessages[InputIDs.EMAIL].error) })
      .regex(
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/,
        intl.formatMessage(formMessages[InputIDs.EMAIL].error.valid),
      ),
    [CheckboxIDs.APPROVAL]: zod.boolean({ required_error: '' }).refine((val) => val),
  });
